import type { QueryFunctionContext, UseQueryResult } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import type {
    ILeadScoringSummaryDto,
    ILeadScoringSummaryPayload,
} from "app/pages/sales-intelligence/modules/ai-agent/types/leadScoring";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import { leadScoringAgentQueryKeys } from "../key-factory/factory";

const SUMMARY_GC_TIME_MS = 10 * 60 * 1000;

const useLeadScoringSummaryQuery = (
    payload: ILeadScoringSummaryPayload,
    isEnabled: boolean,
): UseQueryResult<ILeadScoringSummaryDto> => {
    return useQuery({
        retry: false,
        enabled: isEnabled,
        staleTime: Infinity,
        gcTime: SUMMARY_GC_TIME_MS,
        queryKey: leadScoringAgentQueryKeys.summary(payload.domain, payload.score, payload.triggeredRuleId),
        queryFn({ signal }: QueryFunctionContext): Promise<ILeadScoringSummaryDto> {
            return salesApiService.aiAgent.leadScoring.fetchSummary(payload, {
                cancellation: signal,
            });
        },
    });
};

export default useLeadScoringSummaryQuery;
